<template>
  <div class="smart-recap"> <!-- mobile version -->
    <p class="smart-recap__title">Completa la prenotazione!</p>
    <div class="smart-recap__wrap">
      <rate-points v-if="property_data.amount_points" :amount_points="property_data.amount_points" />
      <div v-else class="smart-recap__text">
        <span>€ {{ property_data.live_price }}</span>
        <span>include gestione e assistenza</span>
      </div>
      <vb-icon class="smart-recap__icon" :name="'angle_small_right'" :color="'fff'" :size="32" />
    </div>
  </div>
</template>

<script>
import RatePoints from "@liveeps/components/atoms/rate-points"

export default {
  name: 'smart-recap',

  components: {
    'rate-points': RatePoints,
  },

  props: {
    property_data: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .smart-recap {
    background-color: var(--primary);
    color: $white;
    text-align: center;
    padding: $grid-gutter-width / 3;
    border-radius: $border-radius-lg * 2;
    position: relative;
    box-shadow: 0 0 0 1px rgba(0,0,0, .02),0 5px 15px 0 rgba(0,0,0, .10);

    &__title {
      font-weight: $vb-font-weight-semibold;
      font-size: $font-size-lg;
      margin-bottom: 5px;
    }

    span {
      display: block;

      &:first-child {
        color: var(--secondary);
        font-weight: $vb-font-weight-semibold;
        font-size: $font-size-xl;
      }

      &:last-child {
        font-size: $font-size-sm;
        opacity: .5;
      }
    }

    &__icon {
      width: 32px;
      height: 32px;
      position: absolute;
      top: 0;
      bottom: 0;
      right: 10px;
      margin: auto;
    }

    ::v-deep {
      .rate-points {
        &__content,
        &__currency,
        &__currency span,
        &__content span {
          color: $white;
        }

        &__currency span:after {
          background-color: $white;
        }

        .vb-icon {
          --color: #fff !important;
        }
      }
    }
  }

</style>